import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Row, Col, Card, Form, Input, Button, Select, Alert, notification } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import { storage } from 'helpers';
import definitionService from 'services/definition.service';
import terminalService from 'services/terminal.service';
import branchService from 'services/branch.service';

const { Option } = Select;

const TerminalAdd = (props) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [branches, setBranches] = useState([]);
  const [clientModels, setClientModels] = useState([]);
  const [terminalVendors, setTerminalVendors] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [globalError] = useState(false);
  const branchId = useParams()?.branchId;
  const currentMerch = storage.get('selectedMerch');

  useEffect(() => {
    getTerminalVendors();
    getBranchDetails();
    getBranches();
  }, []);

  const getBranchDetails = async () => {
    try {
      if (currentMerch?.number && branchId) {
        const { payload } = await branchService.getBranchDetail(currentMerch?.number, branchId);
        setSelectedBranch(payload);
        console.log('Selected Branch:', selectedBranch);
      }
    } catch (branchError) {
      setSelectedBranch(null);
      notification.error({
        message: 'İşlem Başarısız',
        description: branchError.message || 'Bir hata oluştu.',
      });
    }
  };

  const getBranches = async () => {
    try {
      if (currentMerch?.number) {
        const { payload } = await branchService.getBranchesByMerch(currentMerch?.number);
        setBranches(payload);
      }
    } catch (branchesError) {
      setBranches([]);
      notification.error({
        message: 'İşlem Başarısız',
        description: branchesError.message || 'Bir hata oluştu.',
      });
    }
  };

  const getClientModels = async (vendorId) => {
    try {
      const models = await definitionService.getDefinition('client-model', { vendorId });
      setClientModels(models.payload);
    } catch (clientModelsError) {
      notification.error({
        message: 'İşlem Başarısız',
        description: clientModelsError.message || 'Bir hata oluştu.',
      });
    }
  };

  const getTerminalVendors = async () => {
    try {
      const vendorData = await definitionService.getDefinition('client-marka');
      setTerminalVendors(vendorData.payload);
    } catch (vendorsError) {
      notification.error({
        message: 'İşlem Başarısız',
        description: vendorsError.message || 'Bir hata oluştu.',
      });
    }
  };

  const handleSubmit = async (values) => {
    setSubmitting(true);
    try {
      await terminalService.addTerminal(currentMerch?.number, {
        ...values,
        branchName: branches.find((branch) => branch.BranchId === values.branchId)?.BranchTitle,
        terminalVendorId: values?.clientMarkaId || undefined,
      });
      notification.success({
        message: 'İşlem Başarılı',
        description: 'Terminal eklendi!',
      });
      navigate(-1);
    } catch (submitError) {
      notification.error({
        message: 'İşlem Başarısız',
        description: submitError.message || 'Bir hata oluştu.',
      });
    } finally {
      setSubmitting(false);
    }
  };

  const customFilter = (input, option) =>
    option?.children
      ?.toString()
      ?.toLocaleUpperCase('tr-TR')
      ?.includes(input?.toLocaleUpperCase('tr-TR'));

  return (
    <PageContainer title="Yeni Terminal Başvurusu" onBack={() => navigate(-1)}>
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        {globalError && (
          <Form.Item>
            <Alert message={globalError} type="error" showIcon />
          </Form.Item>
        )}
        <Row gutter={[20, 20]}>
          <Col span={24}>
            <Card type="inner" title="Terminal Bilgileri">
              <Form.Item
                name="branchId"
                label="Şube Adı - Şube No :"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <Select
                  showSearch
                  placeholder="Terminal Eklenecek Şubeyi Seçiniz."
                  style={{ width: '100%' }}
                  filterOption={customFilter}
                >
                  {branches?.map((branch) => (
                    <Option key={branch.BranchId} value={branch.BranchId}>
                      {branch.BranchTitle} - {branch.BranchId}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="clientMarkaId"
                label="Marka"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <Select
                  showSearch
                  placeholder="Marka Seçiniz."
                  style={{ width: '100%' }}
                  onChange={getClientModels}
                  filterOption={customFilter}
                >
                  {terminalVendors?.map((vendor) => (
                    <Option key={vendor.ClientMarkaId} value={vendor.ClientMarkaId}>
                      {vendor.Name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="clientModelId"
                label="Model"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <Select
                  showSearch
                  placeholder="Model Seçiniz."
                  style={{ width: '100%' }}
                  filterOption={customFilter}
                >
                  {clientModels?.map((clientModel) => (
                    <Option key={clientModel.ClientModelId} value={clientModel.ClientModelId}>
                      {clientModel.Name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="sicilNumber"
                label="Terminal Sicil No"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <Input className="input__default" placeholder="Terminal Sicil No" />
              </Form.Item>
            </Card>
          </Col>
        </Row>
        <Form.Item className="text-align-right">
          <Button
            className="button button__fill"
            type="primary"
            htmlType="submit"
            disabled={submitting}
            loading={submitting}
          >
            Kaydet
          </Button>
        </Form.Item>
      </Form>
    </PageContainer>
  );
};

export default TerminalAdd;
